
import Done from '@/components/Done.vue'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TPBlock',
  props: {
    value: Number,
    done: Boolean,
    type: String,
  },
  components: {
    'tp-done': Done,
  },
  data: function () {
    return {
      types: {
        gpu: 'gpu',
        ram: 'ram',
        hdd: 'hdd',
        cpu: 'cpu',
      },
    }
  },
  methods: {
    isImageVisible(type: string): boolean {
      if (this.type === type) {
        return true
      }
      return false
    },
  },
})
